import { HStack, Text } from '@direct-frontend/components';
import {
    PAGE_TITLE_SETTINGS_ABOUT,
    PAGE_TITLE_SETTINGS_API,
    PAGE_TITLE_SETTINGS_BITRIX,
    PAGE_TITLE_SETTINGS_BUY_BUTTON,
    PAGE_TITLE_SETTINGS_DOMAIN,
    PAGE_TITLE_SETTINGS_EMAIL_NOTIFICATIONS,
    PAGE_TITLE_SETTINGS_FEEDBACK,
    PAGE_TITLE_SETTINGS_INTEGRATIONS,
    PAGE_TITLE_SETTINGS_INVENTORY,
    PAGE_TITLE_SETTINGS_LOGISTICS,
    PAGE_TITLE_SETTINGS_MANAGERS,
    PAGE_TITLE_SETTINGS_ORDER,
    PAGE_TITLE_SETTINGS_PAYMENT,
    PAGE_TITLE_SETTINGS_PRODUCT_FEED,
    PAGE_TITLE_SETTINGS_SEO,
    PAGE_TITLE_SETTINGS_YA_METRIKA,
    PAGE_TITLE_SETTINGS_YCP_API,
} from '#shared/lib/constants';
import {
    settingsAboutRoute,
    settingsApiRoute,
    settingsBuyButtonRoute,
    settingsDomainRoute,
    settingsEmailNotificationsRoute,
    settingsFeedbackRoute,
    settingsIntegrationsRoute,
    settingsInventoryRoute,
    settingsLogisticsRoute,
    settingsLogisticsWarehouseEditRoute,
    settingsManagersRoute,
    settingsOrderRoute,
    settingsOtherRoute,
    settingsPaymentRoute,
    settingsProductFeedRoute,
    settingsRoute,
    settingsSeoRoute,
    settingsYaMetrikaRoute,
    settingsYcpRoute,
} from '#shared/lib/routes';
import { type MenuItem, type SidebarMenuItem } from '../types';

export const PRODUCT_FEED_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_PRODUCT_FEED,
    routes: [settingsProductFeedRoute.route],
    label: PAGE_TITLE_SETTINGS_PRODUCT_FEED,
    href: settingsProductFeedRoute.getUrl(),
    itemId: 'product-feed',
};

export const LOGISTICS_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_LOGISTICS,
    routes: [settingsLogisticsRoute.route, settingsLogisticsWarehouseEditRoute.route],
    label: PAGE_TITLE_SETTINGS_LOGISTICS,
    href: settingsLogisticsRoute.getUrl(),
    itemId: 'logistics',
};

export const DOMAIN_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_DOMAIN,
    routes: [settingsDomainRoute.route],
    label: PAGE_TITLE_SETTINGS_DOMAIN,
    href: settingsDomainRoute.getUrl(),
    itemId: 'domain',
};

export const SEO_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_SEO,
    routes: [settingsSeoRoute.route],
    label: PAGE_TITLE_SETTINGS_SEO,
    href: settingsSeoRoute.getUrl(),
    itemId: 'seo',
};

export const FEEDBACK_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_FEEDBACK,
    routes: [settingsFeedbackRoute.route],
    label: PAGE_TITLE_SETTINGS_FEEDBACK,
    href: settingsFeedbackRoute.getUrl(),
    itemId: 'feedback',
};

export const PAYMENT_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_PAYMENT,
    routes: [settingsPaymentRoute.route],
    label: PAGE_TITLE_SETTINGS_PAYMENT,
    href: settingsPaymentRoute.getUrl(),
    itemId: 'payment',
};

export const MANAGERS_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_MANAGERS,
    routes: [settingsManagersRoute.route],
    label: PAGE_TITLE_SETTINGS_MANAGERS,
    href: settingsManagersRoute.getUrl(),
    itemId: 'roles',
};

export const ABOUT_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_ABOUT,
    routes: [settingsAboutRoute.route],
    label: PAGE_TITLE_SETTINGS_ABOUT,
    href: settingsAboutRoute.getUrl(),
    itemId: 'aboutCompany',
};

export const YCP_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_YCP_API,
    routes: [settingsYcpRoute.route],
    label: PAGE_TITLE_SETTINGS_YCP_API,
    href: settingsYcpRoute.getUrl(),
    itemId: 'ycp',
};

export const BITRIX_MENU_ITEM: SidebarMenuItem = {
    ...YCP_MENU_ITEM,
    title: PAGE_TITLE_SETTINGS_BITRIX,
    label: PAGE_TITLE_SETTINGS_BITRIX,
};

export const OTHER_MENU_ITEM: SidebarMenuItem = {
    title: (
        <HStack gap="4">
            <Text size="s" role="main">
                Другое
            </Text>
            <Text size="s" bold color="red">
                NDA
            </Text>
        </HStack>
    ),
    routes: [settingsOtherRoute.route],
    label: 'Другое',
    href: settingsOtherRoute.getUrl(),
    itemId: 'other',
};

export const INVENTORY_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_INVENTORY,
    routes: [settingsInventoryRoute.route],
    label: PAGE_TITLE_SETTINGS_INVENTORY,
    href: settingsInventoryRoute.getUrl(),
    itemId: 'inventory',
};

export const INTEGRATIONS_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_INTEGRATIONS,
    routes: [settingsIntegrationsRoute.route],
    label: PAGE_TITLE_SETTINGS_INTEGRATIONS,
    href: settingsIntegrationsRoute.getUrl(),
    itemId: 'integrations',
};

export const YA_METRIKA_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_YA_METRIKA,
    routes: [settingsYaMetrikaRoute.route],
    label: PAGE_TITLE_SETTINGS_YA_METRIKA,
    href: settingsYaMetrikaRoute.getUrl(),
    itemId: 'ya-metrica',
};

export const BUY_BUTTON_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_BUY_BUTTON,
    routes: [settingsBuyButtonRoute.route],
    label: PAGE_TITLE_SETTINGS_BUY_BUTTON,
    href: settingsBuyButtonRoute.getUrl(),
    itemId: 'buy-button',
};

export const ORDER_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_ORDER,
    routes: [settingsOrderRoute.route],
    label: PAGE_TITLE_SETTINGS_ORDER,
    href: settingsOrderRoute.getUrl(),
    itemId: 'order',
};

export const API_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_API,
    routes: [settingsApiRoute.route],
    label: PAGE_TITLE_SETTINGS_API,
    href: settingsApiRoute.getUrl(),
    itemId: 'api',
};

export const EMAIL_NOTIFICATIONS_MENU_ITEM: SidebarMenuItem = {
    title: PAGE_TITLE_SETTINGS_EMAIL_NOTIFICATIONS,
    routes: [settingsEmailNotificationsRoute.route],
    label: PAGE_TITLE_SETTINGS_EMAIL_NOTIFICATIONS,
    href: settingsEmailNotificationsRoute.getUrl(),
    itemId: 'email-notifications',
};

const settingsRoutes = [
    settingsRoute.route,
    settingsAboutRoute.route,
    settingsLogisticsRoute.route,
    settingsDomainRoute.route,
    settingsSeoRoute.route,
    settingsPaymentRoute.route,
    settingsInventoryRoute.route,
    settingsApiRoute.route,
    settingsOtherRoute.route,
    settingsManagersRoute.route,
    settingsLogisticsWarehouseEditRoute.route,
    settingsFeedbackRoute.route,
    settingsOrderRoute.route,
    settingsEmailNotificationsRoute.route,
    settingsYaMetrikaRoute.route,
    settingsProductFeedRoute.route,
    settingsYcpRoute.route,
];

export const SETTINGS_ROOT_MENU_ITEM: MenuItem = {
    href: settingsRoute.getUrl(),
    iconLabel: '',
    itemId: 'settings',
    permission: 'settings',
    routes: settingsRoutes,
    label: 'Настройки',
    title: 'Настройки',
};

export const SETTINGS_INTEGRATIONS_MENU_ITEM: MenuItem = {
    ...INTEGRATIONS_MENU_ITEM,
    iconLabel: '',
    permission: 'settings',
};
